const helpReason = ['First Job' , 'Internship' ,'Career Change/Promotion','Practical Learning','Build Great CV/Profile','Other'];

const timeToCall = ['09:00 AM - 12:00 PM','12:00 PM - 03:00 PM','03:00 PM - 06:00 PM','06:00 PM - 09:00 PM','9:00 PM - 12:00 AM']




export {helpReason , timeToCall};